import React, { Component } from "react";
import { Row, Col, Menu, Dropdown, Avatar } from "antd";
import {
  CaretDownOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { Link, withRouter } from "react-router-dom";
import UserContext from "../../Page/UserContext/UserContext";
import "./Header.css";
import Logo from "../../svg/svgicon/LogoSmall";
import HeaderMenu from "../../svg/svgicon/HeaderMenu";
class Header extends Component {
  static contextType = UserContext;
  state = {
    menu: [],
    sMenu: 0, //this.props.sMenu,
  };

  onMenuChange = (e) => {
    if (e.key) {
      this.setState({
        sMenu: parseInt(e.key),
      });
    }
  };

  onLogin = () => {
    this.props.history.push("/login");
  };

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    this.setState({
      menu: [
        {
          id: 0,
          name: "Нүүр хуудас",
          page: "/home",
        },
        {
          id: 1,
          name: "Тендер",
          page: "/tender/1",
        },
        {
          id: 2,
          name: "Хамтран ажиллах санал",
          page: "/joinwork",
        },
        {
          id: 3,
          name: "Нийлүүлэгч",
          page: "/vendors",
        },
        {
          id: 4,
          name: "Тохиргоо",
          page: "/config",
        },
        {
          id: 5,
          name: "Tableau",
          page: "/report",
        },
      ],
    });
  };

  render() {
    let menu = null;
    if (this.state.menu.length > 0) {
      menu = (
        <Menu onClick={this.onMenuChange}>
          {this.state.menu.map((r) => {
            return (
              <Menu.Item key={r.id}>
                <Link className="menuItem" to={r.page}>
                  {r.name}
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      );
    }

    let menuName = "";
    if (this.state.menu.length > 0) {
      menuName = this.state.menu[this.state.sMenu].name;
    }
    let userInfo = (
      <Menu>
        <Menu.Item
          key={0}
          icon={<LogoutOutlined />}
          style={{ width: "100px", textAlign: "center" }}
          onClick={this.props.logout}
        >
          <a>Гарах</a>
        </Menu.Item>
      </Menu>
    );

    return (
      <div>
        <Row
          style={{
            backgroundColor: "#292D37",
            height: "48px",
            position: "fixed",
            zIndex: "2",
            width: "100%",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
          align="middle"
        >
          <Col span={12}>
            <Row align="middle" gutter={[16, 16]}>
              <Col>
                <HeaderMenu />
              </Col>
              <Col>
                <Link to="/">
                  <Logo />
                </Link>
              </Col>
              <Col>
                <div className="divider"></div>
              </Col>
              <Col>
                <Dropdown overlay={menu} trigger={["click"]}>
                  <div>
                    <span className="menu">{menuName}</span>{" "}
                    <span className="downOutlined">
                      <CaretDownOutlined />
                    </span>
                  </div>
                </Dropdown>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row justify="end" align="middle" gutter={[16, 16]}>
              {/* <Col>
                <NotificationIcon />
              </Col> */}
              <Col>
                <div className="username">{this.props.username}</div>
              </Col>
              <Col>
                <Dropdown
                  placement="bottomRight"
                  overlay={userInfo}
                  trigger={["click"]}
                >
                  <Avatar
                    style={{ cursor: "pointer" }}
                    size={32}
                    icon={<UserOutlined />}
                  ></Avatar>
                </Dropdown>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
Header.contextType = UserContext;
export default withRouter(Header);
